import { AxiosRequestConfig } from 'axios';
import samuIncidentServices from '../services/samuServices';
import { IncidentPostRequest } from '../@types/incidentTypes';

export async function fetchPaginatedSamuIncidents(config: AxiosRequestConfig) {
  const response = await samuIncidentServices.getSamuIncidents(config);
  return response;
}

export async function fetchSamuIncidentById(id: string) {
  const response = await samuIncidentServices.getSamuIncidentById(id);
  return response;
}

export async function fetchSamuIncidentsTileKey(config: AxiosRequestConfig) {
  config.params = {
    ...config.params,
    tileKey: true
  };
  const response = await samuIncidentServices.getSamuIncidents(config);
  return response;
}

export async function deleteSamuIncidentById(id: string) {
  const response = await samuIncidentServices.deleteSamuIncidentById(id);
  return response;
}

export async function createSamuIncident(samuIncidentData: IncidentPostRequest) {
  const response = await samuIncidentServices.createSamuIncident(samuIncidentData);
  return response;
}

export async function getInformationChartData(config: AxiosRequestConfig) {
  const response = await samuIncidentServices.getInformationChartData(config);
  return response;
}